import Editor from '../../../../Forms/EditorText';
import React, { useRef, useState } from 'react';
import { Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { toast } from 'react-toastify';
import { addLetterComment, replyLetterEmail } from '../../../../../Features/letterBox/api/letterBox.api';

export default function LetterNoteModal({ noteID, progettoID, emailID, onClose }: { noteID: number; emailID: number; progettoID?: number | null; onClose: () => void }) {
    const [mode, setMode] = useState<'internal' | 'reply'>('internal');
    const [description, setDescription] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const pending = useRef(false);
    const submit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (pending.current) return;
        if (!progettoID || progettoID <= 0) { setError('ID del progetto non disponibile. Riapri il dettaglio email.'); return; }
        if (mode === 'reply' && (!emailID || emailID <= 0)) { setError('ID email non disponibile. Riapri il dettaglio email.'); return; }
        const content = new DOMParser().parseFromString(description, 'text/html');
        if (!(content.body.textContent ?? '').replace(/\u00a0/g, ' ').trim()) { setError('Inserisci la descrizione.'); return; }
        pending.current = true;
        setSaving(true);
        setError('');
        try {
            const payload = { ID: noteID, progetto_id: progettoID, descrizione: description.trim() };
            if (mode === 'internal') await addLetterComment(payload);
            else await replyLetterEmail({ ...payload, EmailID: emailID });
            toast.success(mode === 'internal' ? 'Nota aggiunta.' : 'Risposta inviata.');
            onClose();
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Errore durante invio del messaggio.');
        } finally {
            pending.current = false;
            setSaving(false);
        }
    };
    return (
        <Modal size='lg' isOpen centered toggle={saving ? undefined : onClose} backdrop={saving ? 'static' : true} keyboard={!saving}>
            <ModalHeader toggle={saving ? undefined : onClose}>{mode === "internal" ? "Aggiungi nota" : "Rispondi all'email"}</ModalHeader>
            <form onSubmit={submit} className="w-100">
                <ModalBody>
                    {error && <Alert color="danger">{error}</Alert>}
                    <div className="mb-3">
                        <label htmlFor="letter-note-mode" className="form-label">Tipo</label>
                        <select id="letter-note-mode" className="form-select" disabled={saving} value={mode} onChange={event => setMode(event.target.value as 'internal' | 'reply')}>
                            <option value="internal">Nota interna</option>
                            <option value="reply">Rispondi all'email</option>
                        </select>
                    </div>
                    <label id="letter-note-description-label" className="form-label">Descrizione</label>
                    <div role="group" aria-labelledby="letter-note-description-label">
                        <Editor value={description} onChange={setDescription} height={360} disabled={saving} />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button type="button" color="secondary" disabled={saving} onClick={onClose}>Annulla</Button>
                    <Button type="submit" color="primary" disabled={saving}>{saving ? 'Invio in corso...' : mode === 'internal' ? 'Aggiungi nota' : 'Invia risposta'}</Button>
                </ModalFooter>
            </form>
        </Modal>
    );
}